import classNames from "classnames";
import React from "react";

const classNamePrefix = "Paper";

type PaperProps = React.HTMLAttributes<HTMLDivElement>;

export const Paper = React.forwardRef(
  (props: PaperProps, ref?: React.ForwardedRef<HTMLDivElement>) => {
    const { className, ...restProps } = props;
    return (
      <div
        ref={ref}
        {...restProps}
        className={classNames(className, classNamePrefix)}
      />
    );
  },
);
